import { render } from "./ResourceTable.vue?vue&type=template&id=8d93c0d0"
import script from "./ResourceTable.vue?vue&type=script&lang=js"
export * from "./ResourceTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/roland/vscode/yachtbroker/portal/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ResourceTable.vue"]])

export default __exports__